// extracted by mini-css-extract-plugin
export default {"center":"styles_center__1rKws","h1":"styles_h1__UcR4H","h2":"styles_h2__ubncY","wrapper":"styles_wrapper__kqEUu","img":"styles_img__WBuO4","repo__desc":"styles_repo__desc__xbFed"};